import { NgModule } from '@angular/core';
import { AgentRelationSearchComponent } from './agent-relation-search/agent-relation-search.component';
import { CommonModule } from '@angular/common';
import { SystemCommonModule } from '../system-common/system-common.module';
import { ModalModule } from 'ngx-bootstrap/modal';
import { AgentRelationRoutingModule } from './agentRelation-routing.module';
import { AgentRelationService } from './services/agentRelation.service';
import { TeamAgentRelationSearchComponent } from './team-agent-relation-search/team-agent-relation-search.component';

@NgModule({
  declarations: [AgentRelationSearchComponent, TeamAgentRelationSearchComponent],
  imports: [CommonModule, SystemCommonModule, AgentRelationRoutingModule, ModalModule.forRoot()],
  providers: [AgentRelationService],
})
export class AgentRelationModule {}
